import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  error: {
    margin: `${theme.spacing(1)}px 0`,
    fontSize: 12,
    color: theme.palette.error.main,
  },
}));
